import { library, dom } from "@fortawesome/fontawesome-svg-core"

import {
  faEye,
  faQrcode,
  faLink,
  faChevronRight,
  faCogs,
  faPencilPaintbrush,
  faRocket,
  faRocketLaunch,
  faCoins,
  faShareSquare,
  faMap,
  faClock,
  faImages,
  faConciergeBell,
  faPaperPlane,
  faCheck,
  faCheckCircle,
  faExclamationCircle,
  faPlus,
  faEdit,
  faEllipsisV,
  faHome,
  faSortDown,
  faSortUp,
  faSort,
  faStore,
  faCreditCard,
  faTrash,
  faArchive,
  faSignOutAlt,
  faPhone,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faPen,
  faUtensils,
  faPlusCircle,
  faStoreSlash,
  faUserClock,
  faUmbrellaBeach,
  faSmoking,
  faHeat,
  faCarSide,
  faChild,
  faWheelchair,
  faBagsShopping,
  faGlassCheers,
  faBars,
  faWifi,
  faParking,
  faAirConditioner,
  faSeedling,
  faPepperHot,
  faTicketAlt,
  faEyeSlash,
  faSave,
  faEnvelope,
  faUserCircle,
  faWandMagicSparkles,
  faSpinnerThird,
  faCamera,
  faArrowRight,
  faArrowUpRightFromSquare,
  faArrowLeft,
  faXmark,
  faSliders,
  faChevronLeft,
  faChevronDown,
  faCloudArrowUp,
  faGlobe,
  faCircleInfo,
  faCircleQuestion,
  faTriangleExclamation,
  faArrowRotateLeft,
  faChartLine,
  faUser,
  faGift,
  faShieldCheck,
  faMapLocationDot,
  faLocationDot,
  faCopy,
  faLock,
  faMoped,
  faCalendarCheck,
  faDog,
  faPlateUtensils,
  faRestroom,
  faWheelchairMove,
  faWallet,
  faMoonStars,
  faMugHot,
  faSalad,
  faVolumeSlash,
  faStamp,
  faGear,
  faSparkles,
  faWineGlass,
  faPrint,
  faDownload,
  faScissors,
  faFile,
} from "@fortawesome/pro-regular-svg-icons"

import { faLinkedin, faXTwitter, faPinterest, faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"

// Brands icons
library.add(
  faEye,
  faQrcode,
  faLink,
  faChevronRight,
  faCogs,
  faPencilPaintbrush,
  faRocket,
  faRocketLaunch,
  faCoins,
  faShareSquare,
  faMap,
  faClock,
  faImages,
  faConciergeBell,
  faPaperPlane,
  faCheck,
  faCheckCircle,
  faExclamationCircle,
  faPlus,
  faEdit,
  faEllipsisV,
  faHome,
  faSortDown,
  faSortUp,
  faSort,
  faStore,
  faCreditCard,
  faTrash,
  faArchive,
  faSignOutAlt,
  faPhone,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faPen,
  faUtensils,
  faPlusCircle,
  faStoreSlash,
  faUserClock,
  faUmbrellaBeach,
  faSmoking,
  faHeat,
  faCarSide,
  faChild,
  faWheelchair,
  faBagsShopping,
  faGlassCheers,
  faBars,
  faWifi,
  faParking,
  faAirConditioner,
  faSeedling,
  faPepperHot,
  faTicketAlt,
  faEyeSlash,
  faSave,
  faEnvelope,
  faUserCircle,
  faWandMagicSparkles,
  faSpinnerThird,
  faCamera,
  faArrowRight,
  faArrowUpRightFromSquare,
  faArrowLeft,
  faXmark,
  faSliders,
  faChevronLeft,
  faChevronDown,
  faCloudArrowUp,
  faGlobe,
  faCircleInfo,
  faCircleQuestion,
  faTriangleExclamation,
  faArrowRotateLeft,
  faChartLine,
  faUser,
  faGift,
  faShieldCheck,
  faMapLocationDot,
  faLocationDot,
  faCopy,
  faLock,
  faMoped,
  faCalendarCheck,
  faDog,
  faPlateUtensils,
  faRestroom,
  faWheelchairMove,
  faWallet,
  faMoonStars,
  faMugHot,
  faSalad,
  faVolumeSlash,
  faStamp,
  faGear,
  faSparkles,
  faWineGlass,
  faPrint,
  faDownload,
  faScissors,
  faFile,
)

// Brands icons
library.add(faLinkedin, faXTwitter, faPinterest, faFacebook, faInstagram)

document.addEventListener("turbo:load", () => {
  // Replace any existing <i> tags with <svg> and set up a MutationObserver to
  // continue doing this as the DOM changes.
  dom.watch()
})
